import React from 'react';
import PropTypes from 'prop-types';

const ENTER_KEY = 13;
/**
 * Tabs.Menu
 *  - Individual Tab Menu Item
 */
export function Menu(props) {
  const onClick = (event) => {
    event.stopPropagation();
    props.onClick(props.value);
  };

  const onKeyDown = (event) => event.keyCode === ENTER_KEY && onClick(event);

  return (
    <div
      role="button"
      onKeyDown={onKeyDown}
      onClick={onClick}
      className={props.className}
      tabIndex={props.tabIndex}
      aria-label={`\"${props.children}\" section.`}
    >
      {props.children}
    </div>
  );
}

Menu.propTypes = {
  /**
   * Function to trigger when clicked on Menu
   */
  onClick: PropTypes.func,
  /**
   * Unique Id for Tab
   */
  value: PropTypes.string.isRequired,
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Chil components
   */
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.string,
  ]),
  /**
   * for keyboard navigation
   */
  tabIndex: PropTypes.number,
};

Menu.defaultProps = {
  className: '',
  tabIndex: 0,
};
